/* eslint-disable react/no-array-index-key */
import { Skeleton } from '@/components/ui/skeleton';
import { IonBackButton, IonButtons, IonContent, IonToolbar } from '@ionic/react';

export default function UserProfileSkeleton() {
  return (
    <IonContent fullscreen={true}>
      <div className="flex w-full flex-col overflow-hidden md:rounded-lg max-w-4xl">
        <div id="profile-header" className="relative md:to-background bg-gradient-to-t to-primary/20 dark:to-foreground/20 from-transparent pt-safe md:mt-0">

          {/* Toolbar */}
          <IonToolbar color="transparent" className='px-3 md:hidden'>
            <IonButtons slot="end">
              <Skeleton className="h-10 w-10 rounded-full" />
            </IonButtons>
          </IonToolbar>

          {/* Avatar and Profile Info */}
          <div className="block px-4 pb-6 md:relative md:px-6">
            <div className="flex justify-center md:justify-start">
              <Skeleton className="size-32 border-2 border-card md:size-[128px] rounded-full" />
            </div>
            <div className="flex flex-col justify-between md:flex-row">
              <div className="p-3 md:p-0">
                <div className="flex items-end justify-center md:justify-start">
                  <Skeleton className="h-10 w-48 mb-2" />
                  <Skeleton className="size-8 ml-2 rounded-full" />
                </div>
                <div className="flex flex-row justify-center md:justify-start">
                  <Skeleton className="h-6 w-32" />
                </div>
                <Skeleton className="h-16 w-full mt-2" />
              </div>
              <div className="flex flex-row items-center justify-center space-x-4 p-3 text-center md:justify-end">
                <Skeleton className="h-10 w-32" />
              </div>
            </div>
          </div>

          {/* Social Links */}
          <div className="flex items-center justify-center space-x-4 md:justify-start px-4 md:px-6 pb-4">
            {[1, 2, 3, 4].map((_, index) => (
              <Skeleton key={index} className="size-10 rounded-full" />
            ))}
          </div>
        </div>

        {/* Basic Summary */}
        <div className="relative flex justify-center text-center md:justify-start p-4 gap-10">
          {[1, 2, 3].map((_, index) => (
            <div key={index}>
              <Skeleton className="h-8 w-12 mx-auto mb-1" />
              <Skeleton className="h-4 w-16" />
            </div>
          ))}
        </div>

        {/* Tabs Section */}
        <div className="w-full">

          {/* Tab Content */}
          <div className="space-y-6 p-4">
            {/* Links List */}
            <div className="space-y-4">
              {[1, 2].map((_, index) => (
                <Skeleton key={index} className="h-16 w-full rounded-lg" />
              ))}
            </div>

            {/* Map Placeholder */}
            <Skeleton className="h-6 w-64 mb-2" />
            <Skeleton className="h-64 w-full rounded-lg" />

            {/* Recent Rounds */}
            <Skeleton className="h-6 w-64 mb-4" />
            <div className="space-y-6">
              {[1, 2].map((_, index) => (
                <div key={index} className="space-y-2">
                  <div className="flex gap-4">
                    <Skeleton className="size-[90px] rounded-lg" />
                    <div className="flex-1 space-y-2">
                      <Skeleton className="h-6 w-3/4" />
                      <Skeleton className="h-4 w-1/2" />
                      <Skeleton className="h-4 w-1/4" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </IonContent>
  );
}
